import React from 'react';
import { TableRowProps } from './types';
import { StyledTableRow } from './TableRow.styles';

export default function TableRow(props: TableRowProps) {
  const { children, ...otherProps } = props;

  return <StyledTableRow {...otherProps}>{children}</StyledTableRow>;
}
